<ng-container *ngIf="viewContentInside()">
  <ng-content></ng-content>
</ng-container>
